<div class="pdf-render-content">
  <footer class="pdf-footer-row">
    @if (dateInst.dtp) {
      <div>Created by {{appScope.current_user.name}} on {{currentDate()  | stringDate}}
      </div>
    }
    <div class="right"></div>
    <!--  <div class="right">Powered by MMS WIRE. https://www.metalmanagementsolutions.com</div>-->
  </footer>
</div>
